import { SaveAnalysisButton } from '@modules/analysis/components/SaveAnalysisButton';
import { QuantifySaveActionAlert } from '@modules/quantify/components/QuantifySaveActionAlert';
import {
  useGetQuantifyCompareQuery,
  useGetQuantifyQueryMetadata,
  useHasChangesToBeSaved,
} from '@modules/quantify/hooks';
import { useGetQuantifyChartEQLProps } from '@modules/quantify/hooks/useFetchQuantifyChartData/useGetQuantifyChartEQLProps';
import { useGetQuantifyMetadataV2 } from '@modules/quantify/hooks/useGetQuantifyMetadataV2';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { AnalysisUseCase } from 'generated/graphql';

interface SaveQuantifyActionProps {
  onAnalysisCreate?: () => void;
}

export const SaveQuantifyAction = ({
  onAnalysisCreate,
}: SaveQuantifyActionProps) => {
  const queryMetadata = useGetQuantifyQueryMetadata();
  const eqlProps = useGetQuantifyChartEQLProps();

  const groupByLabel = useQuantifyStore(
    ({ query }) => query.groupByField?.displayName,
  );
  const shouldShowAnomalies = useQuantifyStore(
    ({ query }) => query.shouldShowAnomalies,
  );
  const compareQuery = useGetQuantifyCompareQuery();
  const useCase = compareQuery
    ? AnalysisUseCase.Compare
    : AnalysisUseCase.Default;

  const hasChangesToBeSaved = useHasChangesToBeSaved({
    shouldCheckForValidQuery: true,
  });

  const quantifyMetadata = useGetQuantifyMetadataV2();

  return (
    <SaveAnalysisButton
      metadata={queryMetadata}
      metadataV2={{
        quantify: quantifyMetadata,
      }}
      eqlProps={eqlProps}
      isDisabled={!hasChangesToBeSaved}
      onAnalysisCreate={onAnalysisCreate}
      analysisFormProps={{ secondaryInfoNode: <QuantifySaveActionAlert /> }}
      eventProps={{
        quantifyQueryOptions: {
          showMeLabel: groupByLabel,
          shouldShowAnomalies,
        },
      }}
      useCase={useCase}
      className="quantify-save-button"
    />
  );
};
